import { IdentityBodyAssessMethod, IdentityMeasurementUnit } from '@reg/shared/model';

/**
 * Model to a single body assessment measurement
 */
export class IdentityBodyAssessMeasurement {
    public id: string = null;
    public name: string = null;
    public dataType: string = null;
    public method: IdentityBodyAssessMethod = null;
    public measurementUnit: IdentityMeasurementUnit = null;
    public sequence: number = null;

    public clone(): IdentityBodyAssessMeasurement {
        const clone: IdentityBodyAssessMeasurement = new IdentityBodyAssessMeasurement();
        clone.id = this.id;
        clone.name = this.name;
        clone.dataType = this.dataType;
        clone.sequence = this.sequence;

        if (this.method) {
            clone.method = this.method.clone();
        }

        if (this.measurementUnit) {
            clone.measurementUnit = this.measurementUnit.clone();
        }

        return clone;
    }

    /**
     * Deserialize to json api format
     */
    public deserialize(json: Object, included: Object[]): IdentityBodyAssessMeasurement {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'];
        included = included || json['included'];
        const relationships: Object[] = data['relationships'] || [];

        this.id = data['id'];
        this.name = attrs['name'];
        this.dataType = attrs['dataType'];
        this.sequence = attrs['sequence'];

        const methodLink: Object = relationships['bodyAssessmentMethod'];
        if (methodLink &&
            included &&
            methodLink['data'] &&
            methodLink['data']['id']) {
            const methodId: string = methodLink['data']['id'];
            const methods: Object[] =
                included.filter((i: Object) => i['type'] === 'bodyAssessmentMethod' && i['id'] === methodId);

            if (methods.length === 1) {
                this.method = (new IdentityBodyAssessMethod()).deserialize(methods[0], included);
            }
        } else if (attrs['bodyAssessmentMethodId']) {
            this.method = new IdentityBodyAssessMethod();
            this.method.id = attrs['bodyAssessmentMethodId'];
        }

        const measurementUnitLink: Object = relationships['measurementUnit'];
        if (measurementUnitLink &&
            included &&
            measurementUnitLink['data'] &&
            measurementUnitLink['data']['id']) {
            const measurementUnitId: string = measurementUnitLink['data']['id'];
            const measurementUnits: Object[] =
                included.filter((i: Object) => i['type'] === 'measurementUnit' && i['id'] === measurementUnitId);

            if (measurementUnits.length === 1) {
                this.measurementUnit = (new IdentityMeasurementUnit()).deserialize(measurementUnits[0]);
            }
        } else if (attrs['measurementUnitId']) {
            this.measurementUnit = new IdentityMeasurementUnit();
            this.measurementUnit.id = attrs['measurementUnitId'];
        }

        return this;
    }
}
